import { Box, Typography } from "@mui/material";

const LoadingChartState = () => {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="rgba(255, 255, 255, 0.8)"
      zIndex={10}
      sx={{
        backdropFilter: "blur(2px)",
      }}
    >
      <Typography color="primary" fontWeight="bold">
        Caricamento dati...
      </Typography>
    </Box>
  );
};

export default LoadingChartState;
